import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_protected")({
  beforeLoad: ({ context }) => {
    // 服务器端：执行认证检查
    if (typeof window !== "undefined") {
      return;
    }
    if (context.auth.status === "account_pending") {
      throw redirect({ to: "/account-pending" });
    }
    if (context.auth.status === "anonymous") {
      throw redirect({
        to: "/login",
      });
    }
  },
});
